import {deletePopover} from "../../../hoc/deletePopover";

const DeleteOrganizationBindingModal = deletePopover("DeleteOrganizationBindingModal")

export default DeleteOrganizationBindingModal
